<template>
  <div class="content">
    <NavBar :navtitle="navtitle" :navBlock="navBlock"></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item>
              <el-select v-model="listMenuForm.memberStatus">
                <el-option label="昵稱" value="0"></el-option>
                <el-option label="賬號" value="1"></el-option>
              </el-select>
              <el-input
                v-model="listMenuForm.searchKey"
                placeholder="在左側選擇搜索類別"
              ></el-input>
            </el-form-item>

            <el-form-item label="發信時間" style="margin-left: 200px;">
              <el-date-picker
                v-model="listMenuForm.time"
                type="datetimerange"
                style="width: 400px;"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div class="MenuBtnWrap">
        <div class="btn" @click="search">查詢</div>
        <div class="btn borderBtn" @click="reset">重置</div>
      </div>
      <div class="tableWrap">
        <el-table :data="userInfoList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in userInfoTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>

              <div v-else-if="item.prop === 'content'">
                <el-button @click="showContent(scope.row)" type="text"
                  >查看詳情</el-button
                >
              </div>

              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="發信時間" fixed="right">
            <template slot-scope="scope">
              <div>{{ $getTime(scope.row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="回信内容" fixed="right">
            <template slot-scope="scope">
              <el-button @click="getLetter(scope.row)" type="text"
                >查看詳情</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <!-- v-if="scope.row.authorizationCode != '審核不通過'"  -->
              <el-button @click="toDeled(scope.row)" type="text"
                >刪除</el-button
              >
              <!-- <el-button v-else type="text" style="color:#eee;">查看詳情</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
    <el-dialog
      :visible.sync="fanMoadl"
      :title="letterType == 'out' ? '寄信内容' : '回信内容'"
      center
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="closeFanModal"
    >
      <div v-if="letter">
        <textarea
          class="chart_input"
          disabled
          style="border: none;"
          rows="3"
          v-model="letter"
        ></textarea>
      </div>
      <div v-else>
        <video
          width="60%"
          class="avatar"
          :src="videoUrl"
          controls="controls"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { throttle } from "../../directives/limit";
export default {
  data() {
    return {
      navBlock: "粉絲來信",
      navtitle: "回信列表",
      userInfoList: [],
      listMenuForm: {
        startTime: "",
        endTime: "",
        choice: "",
        reply: "",
        username: "",
        nickname: "",
        memberStatus: "",
        time: []
      },
      fanMoadl: false,
      videoUrl: "",
      letter: "",
      userInfoTable: [
        {
          prop: "username",
          label: "賬號"
        },
        {
          prop: "nickname",
          label: "昵稱",
          width: ""
        },
        {
          prop: "content",
          label: "寄信内容"
        }
      ],
      currentPage: 1,
      total: 10,
      dialogVisible: false,
      letterType: "out",
      has_next: false
    };
  },
  created() {
    this.getUserInfoList();
  },

  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取用户列表
    getUserInfoList() {
      let _this = this;
      _this
        .$get(
          `/request/letter/list?page=${_this.currentPage}&size=10&nickname=${_this.listMenuForm.nickname}&username=${_this.listMenuForm.username}&startTime=${_this.listMenuForm.startTime}&reply=1&endTime=${_this.listMenuForm.endTime}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.total = res.data.total;
            _this.has_next = res.data.has_next;
            _this.userInfoList = res.data.list;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getUserInfoList();
    },
    // 查询
    search() {
      if (this.listMenuForm.memberStatus == "1") {
        this.listMenuForm.username = this.listMenuForm.searchKey;
      } else if (this.listMenuForm.memberStatus === "0") {
        this.listMenuForm.nickname = this.listMenuForm.searchKey;
      }
      if (this.listMenuForm.time.length > 0) {
        this.listMenuForm.startTime = this.$getTime(this.listMenuForm.time[0]);
        this.listMenuForm.endTime = this.$getTime(this.listMenuForm.time[1]);
      }

      let _this = this;
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        startTime: "",
        endTime: "",
        status: "",
        keyword: "",
        username: "",
        nickname: "",
        memberStatus: "",
        time: []
      };
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    //查看回信
    showContent(e) {
      this.letter = e.content;
      this.fanMoadl = true;
      this.img = e.img;
      this.letterType = "out";
    },
    getLetter(e) {
      this.$get(
        `/request/letter/${e.replyId}`,
        {},
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code === "00000") {
          this.letter = res.data.content;
          this.videoUrl = res.data.videoUrl;
          this.fanMoadl = true;
          this.letterType = "send";
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    closeFanModal(){
      this.fanMoadl = false;
      this.letter = "";
      this.videoUrl = "";
    },
    toDeled: throttle(
      function() {
        return true;
      },
      function(e) {
        this.$message.closeAll();
        let _this = this;

        const param = {
          id: e.replyId,
          isValid: 0
        };
        _this
          .$post(`/request/letter/operate`, param, _this.$GLOBAL.jsonConfig)
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.dialogVisible = false;
              if (
                !_this.has_next &&
                _this.userInfoList.length == 1 &&
                _this.currentPage > 1
              ) {
                _this.currentPage--;
              }
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 1000
              });
              _this.getUserInfoList();
            } else {
              _this.dialogVisible = false;
              _this.$propMessage(res.message, "error");
            }
          });
      },
      2000
    )
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .searchForm {
    flex: 1;
  }
  .paddingContent {
    width: 100%;
    .ListMenu {
      display: flex;
    }
    .tableWrap {
      width: 100%;
      margin-top: 0.4rem;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }
    .MenuBtnWrap {
      flex: 1;
    }
  }
}
.chart_input {
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  outline: none;
  padding: 20px;
  resize: none;
  color: #000000;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/letter/replayList.vue